import React from "react";
import { useTranslation } from 'react-i18next';
import Featured from "../components/announcements/Featured";

function Notification() {
  const { t } = useTranslation();
  return (

    <div className="landing_note">
      <p className="text-4">{t('whatsup_txt')}</p>
      <Featured />                  
    </div>

    );
}

export default Notification;
